/**
 * The product API and the product form do not call every field the same thing, and the form only picks up fields
 * whose names match its controls. The tenure unit is returned as loanPeriodUnit but the form control (and the
 * update request) is loanPeriodLengthUnit, so editing a product left the dropdown on its default, Month, and
 * saving sent MONTH for a product that is in days: stepon's daily products were flipped to months four times
 * (5 Oct, 8 Oct, 16 Oct), and three loans were created with a 500-row schedule because of it.
 *
 * Returns a copy of the product with the fields the form needs under the names the form uses.
 */
export function withFormFieldNames(product: Record<string, any>): Record<string, any> {
  const fields = { ...product };
  if (fields['loanPeriodLengthUnit'] == null && fields['loanPeriodUnit'] != null) {
    fields['loanPeriodLengthUnit'] = fields['loanPeriodUnit'];
  }
  // returned as interestRatePeriodUnit, edited as interestPeriodUnit
  fields['interestPeriodUnit'] = fields['interestRatePeriodUnit'];
  return fields;
}
